export const urls = {
  promoCode: '/carts/validate_promo_code',
};
